import { DemoUserObject, usersArray } from "assets/data/usersData";
import { useState } from "react";
import { IconInput, SVG } from "ui";
import userIcon from "assets/img/user_icon.png";
import {
    CustomComponentProps,
    GeneralModalProps
} from "utils/types/generalTypes";

export type AddMembersModalProps = GeneralModalProps &
    CustomComponentProps & {
        members: DemoUserObject[];
        setMembers: React.Dispatch<React.SetStateAction<DemoUserObject[]>>;
    };

const AddMembersModal = ({
    members,
    setMembers,
    open,
    setOpen,
    className,
    style
}: AddMembersModalProps) => {
    const [filter, setFilter] = useState("");
    const [filteredUsers, setFilterdUsers] = useState(usersArray);

    const filterUsers = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter(e.target.value);
        const val = e.target.value.toLowerCase();
        const tempFilteredArr = usersArray.filter(
            (i) => i.name.toLowerCase().indexOf(val) > -1
        );
        setFilterdUsers(tempFilteredArr);
    };

    const toggleUser = (user: DemoUserObject) => {
        if (members.includes(user)) {
            const newArr = members.filter((u) => u != user);
            setMembers(newArr);
        } else {
            setMembers([...members, user]);
        }
    };

    return (
        <div
            id="post-modal"
            className={`modal is-small has-light-bg ${className} ${open ? "is-active" : ""}`}
            style={style}
        >
            <div className="modal-background"></div>
            <div className="modal-content">
                <div className="card is-new-content">
                    <div className="card-heading">
                        <div className="tabs is-boxed is-fullwidth">
                            <ul id="post-form-tabs-ul">
                                <li className={`post-form-tabs-li pt-10 pl-20`}>
                                    <h3 className="grey-text">Add Members</h3>
                                </li>

                                <li className="close-wrap d-flex flex-j-end mr-10">
                                    <span
                                        className="close-modal"
                                        onClick={() => setOpen(false)}
                                    >
                                        <SVG svg="x" size={16} />
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="card-body">
                        <IconInput
                            value={filter}
                            handleChange={filterUsers}
                            rounded={true}
                        />
                        <div className="field follow-users-field">
                            <ul
                                className="follow-users-ul d-flex flex-col gap-15"
                                id="sign-up-follow-user-ul"
                            >
                                {filteredUsers.map((user) => (
                                    <li
                                        className="follow-user-li pr-10"
                                        key={user.id}
                                    >
                                        <div className="d-flex flex-j-between">
                                            <div className="d-flex flex-j-start">
                                                <img
                                                    src={user.url || userIcon}
                                                    alt={user.name}
                                                />
                                                <div className="follow-user-li-text d-flex flex-col flex-a-start flex-j-center pl-10">
                                                    <h3>
                                                        <a
                                                            href="#"
                                                            className="dark-grey-text white-text"
                                                        >
                                                            {user.name.length >
                                                            10
                                                                ? `${user.name.slice(0, 10)}...`
                                                                : user.name}
                                                        </a>
                                                    </h3>
                                                    <span className="momeento-p">
                                                        @{user.username}
                                                    </span>
                                                </div>
                                            </div>
                                            <div
                                                className="follow-btn d-flex flex-j-center flex-a-center pl-10"
                                                onClick={() => toggleUser(user)}
                                            >
                                                <div
                                                    className={`momeento-svg ${members.includes(user) ? "followed-svg" : "follow-svg"}  follow-user-svg transition-svg`}
                                                ></div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddMembersModal;
